import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import "../styles/LoginPage.css";

export default function LoginPage() {
  // const [showPassword, setShowPassword] = useState(false);
  const [showForgotModal, setShowForgotModal] = useState(false);
  const [step, setStep] = useState(1);
  const [isForgotMode, setIsForgotMode] = useState(false);

  const [loadingEmailBtn, setLoadingEmailBtn] = useState(false);
  const [loadingOtpBtn, setLoadingOtpBtn] = useState(false);
  const [loadingResetBtn, setLoadingResetBtn] = useState(false);

  // const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [resetPassword, setResetPassword] = useState("");

  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const handleEmailLogin = async (e) => {
    e.preventDefault();

    // const gmailRegex = /^[a-zA-Z0-9._%+-]+@gmail\.com$/;

    // if (!gmailRegex.test(email)) {
    //   setError("Please enter a valid Gmail address (example@gmail.com)");
    //   return;
    // }
    const gmailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!gmailRegex.test(email)) {
      setError("Please enter a valid email address");
      return;
    }

    if (password.trim().length < 6) {
      setError("Password must be at least 6 characters long");
      return;
    }

    setError("");
    setLoading(true);

    try {
      const response = await fetch(`${API_BASE_URL}user_login.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          user_mail: email,
          user_password: password,
        }),
      });

      const data = await response.json();

      if (data.head.code === 200) {
        // Save logged-in user info for Navbar
        localStorage.setItem(
          "user",
          JSON.stringify({
            name: data.body.user_name,
            email: email,
            user_id: data.body.user_id,
          })
        );
        localStorage.setItem("isLoggedIn", "true");
        console.log(
          "Redirect value:",
          localStorage.getItem("redirectAfterLogin")
        );
        // Redirect logic
        const redirectPage =
          localStorage.getItem("redirectAfterLogin") || "/";

        localStorage.removeItem("redirectAfterLogin");
        navigate(redirectPage, { replace: true });

      } else {
        setError(data.head.msg || "Login failed. Please try again.");
      }
    } catch (err) {
      console.error("Login API error:", err);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleSendOtp = async (e) => {
    setLoadingEmailBtn(true);
    e.preventDefault();
    try {
      const response = await fetch(`${API_BASE_URL}forgot_password.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          user_mail: email,
        }),
      });

      const data = await response.json();

      if (data.head.code === 200) {
        // Save logged-in user info for Navbar

        localStorage.setItem("userId", data.body.user_id);

        // Redirect logic
        setError("");
        setLoadingEmailBtn(false);


        setStep(2);
      } else {
        setLoadingEmailBtn(false);
        setError(data.head.msg);
      }
    } catch (err) {
      console.error("Login API error:", err);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  const handleVerifyOtp = async (e) => {
    setLoadingOtpBtn(true);

    e.preventDefault();
    try {
      const response = await fetch(`${API_BASE_URL}verify_email_otp.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          user_mail: email,
          otp: otp,
        }),
      });

      const data = await response.json();

      if (data.head.code === 200) {
        // Save logged-in user info for Navbar

        // localStorage.setItem("isLoggedIn", "true");

        // Redirect logic
        setError("");
        setLoadingOtpBtn(false);


        setStep(3);
      } else {
        setLoadingOtpBtn(false);
        setError(data.head.msg);
      }
    } catch (err) {
      console.error("Login API error:", err);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  const handleResetPassword = async (e) => {
    setLoadingResetBtn(true);

    e.preventDefault();
    const userId = localStorage.getItem("userId");
    try {
      const response = await fetch(`${API_BASE_URL}update_password.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          user_id: userId,
          password: resetPassword,
        }),
      });

      const data = await response.json();

      if (data.head.code === 200) {
        // Save logged-in user info for Navbar

        // localStorage.setItem("isLoggedIn", "true");

        // Redirect logic
        alert("Password reset successful!");
        setLoadingResetBtn(false);

        setError("");
        setEmail("");
        setOtp("");
        setResetPassword("");

        setIsForgotMode(false);
        setStep(1);

      } else {
        setLoadingResetBtn(false);
        setError(data.head.msg);
      }
    } catch (err) {
      console.error("Login API error:", err);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      {/* <div className="login-card">
        <h3 className="text-center mb-3 fw-bold">Welcome To Porvaall</h3>

        {error && <div className="alert alert-danger">{error}</div>}

        <form onSubmit={handleEmailLogin}>
          <div className="mb-3 text-start">
            <label className="form-label fw-semibold">Enter your Email</label>
            <input
              type="email"
              className="form-control form-control-lg"
              placeholder="Enter Email Id"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="mb-3 text-start password-container">
            <label className="form-label fw-semibold">Password</label>
            <input
              type={showPassword ? "text" : "password"}
              className="form-control form-control-lg"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <span
              className="password-toggle"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>

          <button
            className="btn btn-primary w-100 fw-semibold py-2"
            type="submit"
            disabled={loading}
          >
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>

        <p className="text-center mt-4 text-muted small-text">
          Don’t have an account?{" "}
          <span
            className="text-primary fw-semibold cursor-pointer"
            onClick={() => navigate("/signup")}
          >
            Sign Up
          </span>
        </p>
        <p className="text-end mt-2">
          <span
            className="text-primary cursor-pointer"
            onClick={() => setIsForgotMode(true)}
          >
            Forgot Password?
          </span>
        </p>
      </div> */}
      <div className="login-card">

        {/* LOGIN MODE */}
        {!isForgotMode && (
          <>
            <h3 className="text-center mb-3 fw-bold">Welcome To Porvaall</h3>

            {error && <div className="alert alert-danger">{error}</div>}

            <form onSubmit={handleEmailLogin}>
              {/* EMAIL */}
              <div className="mb-3 text-start">
                <label className="form-label fw-semibold">Enter your Email</label>
                <input
                  type="email"
                  className="form-control form-control-lg"
                  placeholder="Enter Email Id"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>

              {/* PASSWORD */}
              <div className="mb-3 text-start password-container">
                <label className="form-label fw-semibold">Password</label>
                <input
                  type={showPassword ? "text" : "password"}
                  className="form-control form-control-lg"
                  placeholder="Enter your password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <span
                  className="password-toggle"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div>

              <button className="btn btn-primary w-100 fw-semibold py-2">
                Login
              </button>
            </form>

            <p className="text-center mt-4 text-muted small-text">
              Don’t have an account?{" "}
              <span
                className="text-primary fw-semibold cursor-pointer"
                onClick={() => navigate("/signup")}
              >
                Sign Up
              </span>
            </p>

            <p className="text-end mt-2">
              <span
                className="text-primary cursor-pointer"
                onClick={() => setIsForgotMode(true)}
              >
                Reset / Forgot Password?
              </span>
            </p>
          </>
        )}

        {/* FORGOT PASSWORD MODE */}
        {isForgotMode && (
          <>
            <h3 className="text-center mb-3 fw-bold">Reset Password</h3>

            {/* STEP 1 */}
            {step === 1 && (
              <>
                <input
                  type="email"
                  className="form-control form-control-lg mb-3"
                  placeholder="Enter registered email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                {error && (
                  <div className="alert alert-danger mt-2">
                    {error}
                  </div>
                )}                      <button className="btn btn-primary w-100" onClick={handleSendOtp}>
                  {loadingEmailBtn ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2"></span>
                      Processing...
                    </>
                  ) : (
                    "Send OTP"
                  )}
                </button>
              </>
            )}

            {/* STEP 2 */}
            {step === 2 && (
              <>
                <input
                  type="text"
                  className="form-control form-control-lg mb-3"
                  placeholder="Enter OTP"
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                />
                {error && (
                  <div className="alert alert-danger mt-2">
                    {error}
                  </div>
                )}
                <button className="btn btn-primary w-100" onClick={handleVerifyOtp}>
                  {loadingOtpBtn ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2"></span>
                      Processing...
                    </>
                  ) : (
                    "Verify OTP"
                  )}
                </button>
              </>
            )}

            {/* STEP 3 */}
            {step === 3 && (
              <>
                {/* <input
                               type="password"
                               className="form-control form-control-lg mb-3"
                               placeholder="Enter new password"
                               value={resetPassword}
                               onChange={(e) => setResetPassword(e.target.value)}
                             /> */}
                <div className="position-relative mb-3">
                  <input
                    type={showPassword ? "text" : "password"}
                    className="form-control form-control-lg pe-5"
                    placeholder="Enter new password"
                    value={resetPassword}
                    onChange={(e) => setResetPassword(e.target.value)}
                  />

                  {/* Eye Icon */}
                  <span
                    onClick={() => setShowPassword(!showPassword)}
                    style={{
                      position: "absolute",
                      right: "15px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      fontSize: "18px",
                    }}
                  >
                    {showPassword ? <FaEye /> : <FaEyeSlash />}
                  </span>
                </div>
                {error && (
                  <div className="alert alert-danger mt-2">
                    {error}
                  </div>
                )}
                <button className="btn btn-success w-100" onClick={handleResetPassword}>
                  {loadingResetBtn ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2"></span>
                      Processing...
                    </>
                  ) : (
                    "Submit"
                  )}
                </button>
              </>
            )}

            {/* BACK */}
            <p className="text-center mt-3">
              <span
                className="text-primary cursor-pointer"
                onClick={() => {
                  setError("");
                  setEmail("");
                  setOtp("");
                  setResetPassword("");
                  setIsForgotMode(false);
                  setStep(1);
                }}
              >
                Back to Login
              </span>
            </p>
          </>
        )}

      </div>

      
    </div>
  );
}
